import { useCallback, useEffect, useState } from 'react';

export const useToastDisappear = (timeout: number) => {
    const [toastShown, setToastShown] = useState(false);

    useEffect(() => {
        let toastTimerId: NodeJS.Timeout | undefined;

        if (toastShown) {
            toastTimerId = setTimeout(() => {
                setToastShown(false);
            }, timeout);
        }

        return () => {
            if (toastTimerId) {
                clearTimeout(toastTimerId);
            }
        };
    }, [toastShown, timeout]);

    const triggerToast = useCallback(() => setToastShown(true), [setToastShown]);

    const hideToast = useCallback(() => setToastShown(false), [setToastShown]);

    return {
        toastShown,
        triggerToast,
        hideToast
    };
};
